export default __webpack_public_path__ + "static/media/Byamungu Kakolela.7e4febc9.JPG";